import './styles/style.css'
import './js/main.js'

